import { useState, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { AGB } from './pages/AGB';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const openWizard = () => setIsWizardOpen(true);
  const closeWizard = () => setIsWizardOpen(false);

  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen bg-[#0B0F19]" data-testid="app-container">
        <Navigation onOpenWizard={openWizard} />

        <Routes>
          <Route path="/" element={<Home isWizardOpen={isWizardOpen} openWizard={openWizard} closeWizard={closeWizard} />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
